module.exports = __webpack_public_path__ + "static/media/blogtestpic2.f1c261dc.jpg";